import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import qs from 'qs'
Vue.prototype.$qs = qs
Vue.config.productionTip = false


let env = process.env.NODE_ENV;
if(env == 'development')
{
	window.API_HOST = '/api';
	window.API_HOST_S = '/apis';
}
else
{
	window.API_HOST = '';
	window.API_HOST_S = '';
}

// axios.defaults.baseURL = 'http://news-wma.jinhui365.cn';
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
// Vue.prototype.$ajax = axios
Vue.use(VueAxios, axios)

Vue.filter('dateformat', function (value) {
  if (!value) return '';
  let date = new Date(value);
  let Y = date.getFullYear();
  let M = date.getMonth() + 1;
  let D = date.getDate();
  M = M < 10 ? '0'+ M : M;
  D = D < 10 ? '0'+ D : D;
  return Y + '-' + M + '-' + D;
});

Vue.filter('dateformatYear', function (value) {
  if (!value) return '';
  let date = new Date(value);
  let Y = date.getFullYear();
  let M = date.getMonth() + 1;
  M = M < 10 ? '0'+ M : M;
  return Y + '-' + M ;
});
Vue.filter('dateformatDay', function (value) {
  if (!value) return '';
  let date = new Date(value);
  let D = date.getDate();
  D = D < 10 ? '0'+ D : D;
  return D;
});

router.afterEach(() => {
    window.scrollTo(0,0);
})
// router.beforeRouteLeave((to, from, next)=>{
//   if(window.timer)
//   {
//     clearInterval(window.timer); //关闭
//   }
// })
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
